import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface NavigationPathCSSStyle extends UIComponentCSSStyle
{
    getTitleCSSStyle(): object;
    getArrowCSSStyle(): object;
    getCurrentSelectedTitleCSSStyle(): object;
    getMobileWrapperCSSStyle(): object;
    getMobileTitleCSSStyle(): object;
    getMobileArrowCSSStyle(): object;
    getMobileCurrentSelectedTitleCSSStyle(): object;
    
}

export class NavigationPathCSSStyleImpl extends UIComponentCSSStyleImpl implements NavigationPathCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "60px",
            width: "100%",
            backgroundColor: "#E0E0E0",
            borderBottom: "1px solid " + this.getResources().getColor(Colors.color_14),
            display: "flex",
            flexFlow: "row wrap",
            alignItems: 'center', 
            justifyContent: 'left', 
            textAlign: "left",
            paddingLeft: "4%",
            paddingRight: "5%"
        };
    }

    getTitleCSSStyle(): object {
        return {
            paddingLeft: "20px",
            paddingRight: "20px",
            height: '20px',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h8),
            color:this.getResources().getColor(Colors.color_13),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingTop: "3px",
            position: 'relative', 
        };
    }

    getArrowCSSStyle(): object {
        return {
            height: '12px',
            width: "7px"
        };
    }

    getCurrentSelectedTitleCSSStyle(): object {
        return {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "3px",
            height: '20px',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h8),
            color:"#ED0C6E",
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
        };
    }

    getMobileWrapperCSSStyle(): object
    {
        return {
            height: "40px",
            width: "100%",
            backgroundColor: "#E0E0E0",
            borderBottom: "1px solid " + this.getResources().getColor(Colors.color_14),
            display: "flex",
            flexFlow: "row wrap",
            alignItems: 'center', 
            justifyContent: 'left', 
            textAlign: "left",
            paddingLeft: "4%",
            paddingRight: "5%"
        };
    }

    getMobileTitleCSSStyle(): object {
        return {
            paddingLeft: "10px",
            paddingRight: "10px",
            height: '20px',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize: "14px",
            color:this.getResources().getColor(Colors.color_13),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingTop: "3px",
            position: 'relative', 
        };
    }

    getMobileArrowCSSStyle(): object {
        return {
            height: '10px',
            width: "5px"
        };
    }

    getMobileCurrentSelectedTitleCSSStyle(): object {
        return {
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "3px",
            height: '20px',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize: "14px",
            color:"#ED0C6E",
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/navigationpathcomponent/navigationpathcss.tsx